<template>
	<div id="sign-layer" v-loading="saveLoading">
		<div class="setcontrol-content" id="main">
			<div class="set-sign-control" id="set-sign">
				<div>
					<!-- <div class="pages-head">
						<span class="big">操作帮助</span>
						<span class="sub">
							<el-popover placement="top" title="提示" width="240" trigger="hover">
								<div>
									1、将左侧栏印章拖入中间栏文档中要盖章的位置，印章添加后支持删除
								</div>
								<div>
									2、将左侧栏日期拖入中间栏文档中要盖章的位置（日期章为可选项，如不需要可不添加），日期添加后支持删除
								</div>
								<div>
									3、点击【确认签署】后完成签署
								</div>
								<i class="el-icon-info" style="color: #E6A23C;cursor: help;" slot="reference"></i>
							</el-popover>
						</span>
					</div> -->
					<!-- <el-collapse v-model="helpActive">
						<el-collapse-item title="更多" name="help">
						
						</el-collapse-item>
					</el-collapse> -->
				</div>
				<div class="pages-head" style="position: sticky;top: 0;left: 0;width: 100%;    background: #fff;">
					<span class="big">签章列表</span>
					<span class="sub"> <el-popover placement="right" title="一、操作步骤如下" width="300" trigger="hover">
							<div>
								1、将左侧栏"企业章或人名章"拖入中间栏文档中要盖章的位置。
							</div>
							<div>
								2、将左侧栏"日期章"拖入中间栏文档中要盖章的位置，如果不需要加盖日期章可跳过此步骤。
							</div>
							<div>
								3、点击【确认签署】按钮完成签署。
							</div>
							<div>
								注：已拖拽到文档中的印章可再次拖拽调整位置，也可点击印章右上角"X"进行删除。
							</div>
							<div
								style="color: #303133;font-size: 16px;line-height: 1;margin-top: 14px;margin-bottom: 14px;">
								二、点击图片查看详细操作截图
							</div>
							<div>
								<el-image :src="howToTipSrc" :preview-src-list="[howToTipSrc]"></el-image>
							</div>
							<div slot="reference" style="color: #E6A23C;cursor: help;">操作帮助<i class="el-icon-info"
									style="margin-left: 3px"></i></div>

						</el-popover></span>
				</div>
				<!-- :style="{ height: sealListWrapCalcHeight + 'px' }" -->
				<div class="seal-list-wrap" style="overflow: auto;transition:height .3s ease-in-out">
					<div v-for="(item, usrIdx) in sealInfoArray" :key="usrIdx">
						<div class="set-title">
							<span v-if="item.sealType !== 'date'">
								<span class="tag process" v-if="item.permissionType == 'process'">需审批</span>
								<span class="tag authed" v-if="item.permissionType == 'authed'">已授权</span>
							</span>
							<span>{{ item.sealName }}</span>
						</div>
						<div class="select-sign">
							<div class="sign-list">
								<div class="sign-item">
									<div class="sign-img-box drag-box sign-box" data-type="sign"
										:data-seal-type="item.sealType" :data-seal-id="item.sealId" v-drop>
										<img :src="item.sealImg" alt="" ondragstart="return false" />
									</div>
									<!-- <span>签名</span> -->
								</div>
								<!-- <div class="sign-item" v-if="item.signSubject == 'company'">
								<div class="sign-img-box drag-box seal-box" data-type="seal" :data-seal-type="item.signSubject" :data-seal-id="item.sid" v-drop>
									<img src="../../assets/images/seal.png" alt="">
								</div>
								<span>印章</span>
							</div>
							<div class="sign-item">
								<div class="sign-img-box drag-box date-box" data-type="date" :data-seal-type="item.signSubject" :data-seal-id="item.sid" v-drop>
									<img src="../../assets/images/date.png" alt="">
								</div>
								<span>日期</span>
							</div> -->
							</div>
						</div>
					</div>
					<!--  -->
					<div class="auto-seal-btn-wrap" v-if="positonExistFlag">
						<el-button type="primary" class="auto-seal-btn" @click="handleAutoSeal"
							:disabled="signStatus != 'iSign' || saveLoading">一键盖章
						</el-button>
					</div>

				</div>
				<!--  -->
				<div v-if="needHandwritten == 'yes'">
					<div class="set-title">
						<span>制作签名</span>
					</div>
					<div class="select-sign">
						<div class="sign-list">
							<div class="sign-item">
								<div class="handwrite-img-wrap">
									<div class="drag-box sign-box" v-drop v-if="customHandwriteImg" data-type="sign"
										data-seal-type="person" :data-seal-id="customHandwriteSealId">
										<img :src="customHandwriteImg" alt="" ondragstart="return false">
									</div>
									<el-button icon="el-icon-delete" type="danger" plain circle
										@click="confirmDeleteHandwrite" v-if="customHandwriteImg"></el-button>
									<el-button icon="el-icon-plus" circle @click="handleNewHandWrite" v-else>
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>


				<div style="position: sticky;bottom: 0;left: 0;width: 100%;    background: #fff;"
					v-if="!positonExistFlag"
					v-show="signFileInfoArray[active] && signFileInfoArray[active].fileImgArray.length != 0">
					<!-- <div class="pages-head">
						<span class="big">骑缝章</span>
						<span class="sub"></span>
					</div> -->

					<div class="pages-head">
						<span class="big"><el-checkbox v-model="isPaging"
								style="font-weight: bold;    font-size: 16px;    color: #333333;">骑缝章</el-checkbox></span>
						<span class="sub"> <el-popover placement="right-start" title="提示" width="300" trigger="hover">
								<div>
									勾选骑缝章后，将左侧栏印章拖入中间栏文档中，系统将自动对文档全部页添加骑缝样式的印章。
								</div>

								<div slot="reference" style="color: #E6A23C;cursor: help;"><i class="el-icon-info"></i>
								</div>

							</el-popover></span>
					</div>
					<!-- <div class="set-title-padding">
							<el-checkbox v-model="isPaging">骑缝章</el-checkbox>
						</div>
						<div class="set-title-padding" style="font-size: 13px;    color: #606266;">
							提示：勾选骑缝章复选框后，将左侧栏印章拖入中间栏文档中要盖章的位置，印章将自动定位到文档右侧贴边展示。
						</div> -->


				</div>


			</div>

			<!-- 滑动容器 -->
			<div class="contract-content" ref="cmain">
				<div class="contract-img-content">
					<div class="contract-imgs" id="contract-imgs" ref="contract">
						<div v-for="(item, idx) in signFileInfoArray" :key="idx" v-show="idx == active"
							class="file-item">
							<div class="img-wrap" v-for="(contract, index) in item.fileImgArray" :key="index"
								ref="imgWrap">
								<img :src="contract.src" class="contract-img" alt="" ondragstart="return false" />
								<div v-show="renderOK && signStatus == 'iSign'" v-for="(pos, posIdx) in contract.poss"
									:key="pos.positionId + posIdx" class="position-box" :data-pos-id="pos.positionId"
									:data-seal-type="pos.sealType" :data-type="pos.sealLocationType" :style="{
	left:
		pos.sealLocationType == 'paging'
			? 'unset'
			: (pos.positionX / 50000).toFixed(4) * 100 + '%',
	top: (pos.positionY / 50000).toFixed(4) * 100 + '%',
	right: pos.sealLocationType == 'paging' ? '0' : 'unset',
}">
									<div v-if="
	pos.sealType == 'companyCommon' &&
	pos.sealLocationType == 'position'
" class="seal-pos-box">
										<div class="box-head">企业章</div>
									</div>
									<div v-if="
	pos.sealType == 'companyLegal' &&
	pos.sealLocationType == 'position'
" class="seal-pos-box">
										<div class="box-head">企业法人章</div>
									</div>
									<div v-if="
	pos.sealType == 'person' &&
	pos.sealLocationType == 'position'
" class="sign-pos-box">
										<div class="box-head">签名</div>
									</div>
									<div v-if="
	pos.sealType == 'date' &&
	pos.sealLocationType == 'position'
" class="date-pos-box">
										<div class="box-head">日期</div>
									</div>
									<div v-if="pos.sealLocationType == 'paging'" class="paging-pos-box">
										<div class="box-head">骑缝章</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="contract-page">
				<div class="pages-head">
					<span class="big">文件列表</span>
					<span class="sub">共{{ signFileInfoArray.length }}份</span>
				</div>
				<el-collapse v-model="active" accordion @change="changeCollapse">
					<el-collapse-item :title="item.fileName" :name="idx" v-for="(item, idx) in signFileInfoArray"
						:key="idx">
						<div v-for="(img, imgIdx) in item.fileImgArray" :key="imgIdx" class="page-wrap">
							<img :src="img.src" alt="" ondragstart="return false"
								:class="{ current: item.current == imgIdx }" @click="handleChangeContractImg(imgIdx)" />
							<div class="page" :class="{ current: item.current == imgIdx }">
								{{ imgIdx + 1 + "/" + item.fileImgArray.length }}
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- <div class="all-page">
					<div class="page-item" v-for="(contract, index) in contractImgs" :key="index">
						<div class="page-img" @click="jumpPage(index)">
							<img :src="contract.src" alt="">
							<img v-if="contract.isSign" :src="iconImgs[parseInt(contract.isSign)-1]" class="sign-icon" alt="">
						</div>
						<p class="page-text">第{{index+1}}页</p>
					</div>
				</div> -->
			</div>
		</div>
		<div class="submit-btn clearfix" v-show="contractImgs.length > 0">
			<!-- <el-button type="primary" class="submit" @click="returnHandle">退回</el-button> -->
			<el-button type="primary" class="submit" :disabled="signStatus != 'iSign' || saveLoading"
				@click="handleSave" v-if="(signStatus != 'finish') && (saveLoading || !signSucceed)">确认签署</el-button>
			<el-button v-else-if="signFinishLoading" :disabled="true" style="color: #3296FA;border-color: #c2e0fe;background-color: #ebf5ff;">已完成签署（{{countDownSecond}}）秒后自动返回</el-button>
			<el-button type="primary" class="submit" :disabled="true" v-else>已完成签署</el-button>
		</div>

		<sign-auth ref="auth" :sid="sid" @getAuthCode="getAuthCodeHandle"></sign-auth>

		<el-dialog :close-on-click-modal="false" :append-to-body="true" class="apply-dialog" title="发起用章申请"
			:visible.sync="applyOpen" width="520px" :center="true">
			<div class="main-apply" style="color: #333">
				<div v-for="(item, idx) in applyData" :key="idx">
					<div style="margin: 0 4px 20px; color: #333">
						{{ idx + 1 }}. 您指定的企业印章《{{
		item.sealName
}}》未经过授权，如要使用将发起用章审批流程
					</div>
					<el-descriptions title="" :column="1" border style="margin: 0 4px 20px; color: #333">
						<el-descriptions-item label="审批名称" :labelStyle="{ color: '#333', width: '107px' }">{{
		item.flowName
}}
						</el-descriptions-item>
						<el-descriptions-item label="审批描述" :labelStyle="{ color: '#333', width: '107px' }">{{
		item.flowDesc
}}
						</el-descriptions-item>
						<el-descriptions-item label="审批节点数量" :labelStyle="{ color: '#333', width: '107px' }">{{
		item.nodeNum
}}
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<div style="margin: 0 4px; color: #333">请填写：</div>
				<div class="apply-pane" style="margin-top: 8px">
					<div class="apply-pane-item">
						<el-form @submit.native.prevent :model="applyForm" :rules="applyFormRules" ref="applyForm"
							class="apply-Form">
							<el-form-item label="流程名称" prop="processName" label-width="107px">
								<el-input placeholder="请输入流程名称" v-model="applyForm.processName" maxlength="20">
								</el-input>
							</el-form-item>
							<el-form-item label="流程描述" prop="processDesc" label-width="107px">
								<el-input placeholder="请输入流程描述" v-model="applyForm.processDesc" maxlength="20">
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div style="margin: 0 4px 30px; color: #333">
					流程发起成功后，可到企业控制台查看您发起的审批流程详情
				</div>
				<div class="dialog-btns" style="padding: 0 4px">
					<el-button type="primary" style="padding: 13px 50px" @click="submitApplyHandle" class="btn-ok">继续
					</el-button>
					<el-button type="info" style="float: right; padding: 13px 50px" @click="cancelApply"
						class="btn-cancel">取消
					</el-button>
				</div>
			</div>
		</el-dialog>


		<el-dialog title="手写签名" :visible.sync="handWriteDialogVisible" :close-on-click-modal="false"
			:append-to-body="true" width="400px" custom-class="handwrite-dialog">
			<div id="draw-seal">
				<!-- <div class="tip-success" id="tip-success">绘制成功</div>
				<div class="tip-waning" id="tip-waning"></div> -->
				<div id="seal-main">
					<canvas id="seal-canvas"></canvas>
					<div class="draw-tip">
						<img src="@/assets/images/draw-icon.png" alt="" ondragstart="return false">
						<p>绘制签名</p>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="clearSign">清 除</el-button>
				<el-button type="primary" @click="drawSign">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="选择盖章" :visible.sync="autoSealDialogVisible" :close-on-click-modal="false"
			:append-to-body="true" width="700px" custom-class="autoseal-dialog">

			<div class="auto-seal-wrap">
				<div v-for="(arr, key) in sealInfoArrayMapAutoSeal" :key="key">
					<div class="set-title">
						<span v-if="key == 'companyCommon'">企业章</span>
						<span v-if="key == 'companyLegal'">法定代表人章</span>
						<span v-if="key == 'date'">日期</span>
					</div>


					<div class="auto-seal-list">
						<div v-for="item in arr" :key="item.sealId" class="auto-seal-item"
							@click="handleSelectAutoSeal(item, arr)" :class="{ 'isCheck': item.check }">
							<div>
								<div data-type="sign" :data-seal-type="item.sealType" :data-seal-id="item.sealId">
									<img :src="item.sealImg" alt="" ondragstart="return false" />
								</div>
								<i class="el-icon-success" v-if="item.check"></i>
							</div>
						</div>
					</div>
				</div>

			</div>



			<span slot="footer" class="dialog-footer">
				<el-button @click="autoSealDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleCheckAutoSeal">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// 新增功能点：多文件支持，同文件不同图片间任意拖拽，拖拽位置自动判定
// 企业权限鉴定并新添审批机制
import { Loading } from "element-ui";
import signAuth from "./sign-auth";
import lightHeader from "@/components/lightHeader";
import { getContractImgsApi } from "@/api/sign/flow";
// import { getSignInfoWithSeal, signWithPosition } from "@/api/sign/oa-sign";


import { getSignInfoPcAndH5, signPcAndH5, checkHandwrite } from "@/api/unifysign/sign";


import {
	getSignDetailInfo,
	taskSign,
	checkSealPermission,
	signWithProcess,
	saveLocation,
	getContractPositionApi,
	signSealApi,
	returnContractApi,
	autoLoginByTokenApi,
	getDatePngSrcApi,
	getCompanyLegalApi,
	getSealListApi,
	getContractApi,
	signSealOpenApi,
} from "@/api/sign/sign";
import { getUserSealInfoApi } from "@/api/common";
import { getCompanySealInfoApi } from "@/api/space/signatures";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { mapState } from "vuex";
export default {
	components: {
		lightHeader,
		signAuth,
	},
	data() {
		return {
			sid: "",
			signFileInfoArray: [],
			sealInfoArray: [],
			active: 0,
			scrollWatchStatus: true, //点击右侧缩略图时，暂时停止监听页面滚动
			judgeScope: 40,
			positionSealArray: [],

			showTip: true,
			showCustom: false,
			contractH: null,
			setContractH: null,
			// contractImgs: [],
			selectId: "",
			signImgs: [],

			stitle: " ",
			isTime: "0",
			scrollTop: 0,
			signatoryId: 456,
			renderOK: false,
			positionList: [],
			sealList: [],
			code: "",
			pin: "",
			approvalNum: 0,
			hrefFrom: this.$route.query.hrefFrom,
			dateList: [],
			dateSrc: "",
			lastActive: "",
			saveLoading: false,
			applyOpen: false,
			applyForm: {
				processName: "",
				processDesc: "",
			},
			applyFormRules: {
				processName: [
					{
						required: true,
						message: "请输入流程名称",
						trigger: "change",
					},
				],
				processDesc: [
					{
						required: true,
						message: "请输入流程描述",
						trigger: "change",
					},
				],
			},
			applyData: null,

			pagingId: 0, // 骑缝章id

			positonExistFlag: undefined,
			signSucceed: false,

			handWriteDialogVisible: false,
			customHandwriteImg: "",
			customHandwriteSealId: "",
			needHandwritten: "no",
			signStatus: undefined,

			autoSealDialogVisible: false,

			sealInfoArrayMapAutoSeal: {},
			isPaging: false,

			helpActive: [],

			howToTipSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/signHelp.png",
			countDownSecond: 5,
			signFinishLoading: false
		};
	},
	computed: {
		...mapState(["companyList", "currentSpace"]),
	},
	created() {
		this.sid = this.$route.query.sid;
		this.handleGetSignDetailInfo();
		if (this.$store.state.handwriteBase64 && this.$store.state.handwriteSealId) {
			this.customHandwriteImg = this.$store.state.handwriteBase64;
			this.customHandwriteSealId = this.$store.state.handwriteSealId
		}
	},
	mounted() {
		const _this = this;
		let disX = 0;
		let disY = 0;
		const receiverDom = document.querySelector("#contract-imgs");
		const contractContractDom = document.querySelector(".contract-content");
		receiverDom.onmousedown = () => {
			if (this.positonExistFlag) {
				return;
			}
			const event = event || window.event;
			event.stopPropagation();
			if (
				event.target.classList.contains("el-icon-circle-close") ||
				event.target.classList.contains("contract-img") ||
				event.target.classList.contains("file-item") ||
				event.target.classList.contains("box-head")
			) {
				return;
			}
			let target = event.target;
			while (
				target.tagName != "BODY" &&
				!target.className.includes("drag-box")
			) {
				target = target.parentNode;
			}
			const type = target.getAttribute("data-type");
			const offsetLeft = target.offsetLeft;
			const offsetTop = target.offsetTop;
			const pageHeight = receiverDom
				.querySelectorAll(".file-item")
			[_this.active].querySelectorAll(".img-wrap")[0].offsetHeight;
			disX = event.clientX;
			disY = event.clientY;
			document.onmousemove = function (event) {
				const event2 = event || window.event;
				let iL = event2.clientX - disX + offsetLeft;
				let iT = event2.clientY - disY + offsetTop;
				let targetWrapScrollLeft = +contractContractDom.scrollLeft;
				const maxL = receiverDom.offsetWidth - target.offsetWidth + targetWrapScrollLeft;
				const maxT = receiverDom.offsetHeight - target.offsetHeight;

				// 骑缝章处理
				if (type == "paging") {
					iT <= 0 && (iT = 0);
					iT >= pageHeight - target.offsetHeight &&
						(iT = pageHeight - target.offsetHeight);
					target.style.left = maxL + "px";
					target.style.top = iT + "px";
				} else {
					iL <= 0 && (iL = 0);
					// iT <= 0 && (iT = 0);
					iL >= maxL && (iL = maxL);
					iT >= maxT && (iT = maxT);
					target.style.left = iL + "px";
					target.style.top = iT + "px";
				}
				// target.getElementsByClassName(
				// 	"delete-icon"
				// )[0].style.display = "none";
				return false;
			};
			document.onmouseup = function (event) {
				const event3 = event || window.event;
				// 骑缝章处理
				if (type == "paging") {
					// 更改每一个骑缝章的 top 值
					const allTargetPagingDoms = receiverDom
						.querySelectorAll(".file-item")
					[_this.active].querySelectorAll(
						'.paging-box[data-paging="' +
						target.getAttribute("data-paging") +
						'"]'
					);
					for (let i = 0; i < allTargetPagingDoms.length; i++) {
						allTargetPagingDoms[i].style.top = target.style.top;
					}
				} else {
					const pageHeight = receiverDom
						.querySelectorAll(".file-item")
					[_this.active].querySelectorAll(".img-wrap")[0].offsetHeight;
					_this.judgePage(
						target,
						+target.style.top.split("px")[0],
						pageHeight,
						target.offsetHeight
					);

					receiverDom
						.querySelectorAll(".file-item")
					[_this.active].querySelectorAll(".img-wrap")
					[target.getAttribute("data-page")].appendChild(target);
				}
				// target.getElementsByClassName("delete-icon")[0].style = "";
				document.onmousemove = null;
				document.onmouseup = null;
			};
		};


		window.addEventListener("scroll", this.scrollEventHandler, true);
		// this.getDatePngSrcHandle()
		// this.getUserSealInfoHandle()
		// getSealListApi().then(res => {});
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.scrollEventHandler, true);
	},
	computed: {
		contractImgs() {
			if (this.signFileInfoArray[this.active]) {
				return this.signFileInfoArray[this.active].fileImgArray;
			} else {
				return [];
			}
		},
		// sealListWrapCalcHeight() {
		// 	// if (this.helpActive[0]) {
		// 	// 	return 612
		// 	// } else {
		// 	// 	return 640
		// 	// }
		// 	return 640

		// }
	},
	methods: {
		scrollEventHandler(e) {
			let timeId;
			e = e || window.event;
			if (
				e.target.classList &&
				e.target.classList.contains("contract-content")
			) {
				clearTimeout(timeId);
				timeId = setTimeout(() => {
					this.handleScroll();
				}, 100);
				// this.handleScroll();
			} else {
				clearTimeout(timeId);
			}
		},
		changeCollapse() {
			if (this.active === "") {
				this.active = this.lastActive;
			}
			this.lastActive = this.active;
			// this.$forceUpdate();
			this.signFileInfoArray[this.active].current = 0;
			document
				.getElementById("contract-imgs")
				.getElementsByClassName("file-item")
			[this.active].getElementsByClassName("img-wrap")[0]
				.scrollIntoView({
					behavior: "auto", // 平滑过渡
					block: "start", // 上边框与视窗顶部平齐。默认值
				});
			this.isPaging = false;
		},
		handleScroll() {
			// dom滚动位置
			let scrollTop =
				document.getElementsByClassName("contract-content")[0].scrollTop;
			// console.log(scrollTop)
			if (this.scrollWatchStatus) {
				let scaleFactor = 1;
				this.signFileInfoArray[this.active].fileImgArray.map((v, i) => {
					let offsetTop = document
						.getElementById("contract-imgs")
						.getElementsByClassName("file-item")
					[this.active].getElementsByClassName("img-wrap")[i].offsetTop;
					// 获取监听元素本身高度
					let scrollHeight = document
						.getElementById("contract-imgs")
						.getElementsByClassName("file-item")
					[this.active].getElementsByClassName("img-wrap")[i].scrollHeight;

					if (
						scrollTop >= offsetTop &&
						scrollTop <= offsetTop + scrollHeight * scaleFactor
					) {
						this.signFileInfoArray[this.active].current = i;
					}
				});
			}
		},
		handleChangeContractImg(imgIdx) {
			let timer;
			this.signFileInfoArray[this.active].current = imgIdx;
			this.scrollWatchStatus = false;
			clearTimeout(timer);
			timer = setTimeout(() => {
				document
					.getElementById("contract-imgs")
					.getElementsByClassName("file-item")
				[this.active].getElementsByClassName("img-wrap")
				[imgIdx].scrollIntoView({
					behavior: "auto", // smooth 平滑过渡
					block: "start", // 上边框与视窗顶部平齐。默认值
				});

				let timer;
				clearTimeout(timer);
				timer = setTimeout(() => {
					this.scrollWatchStatus = true;
				}, 1300);
			}, 0);
		},

		handleGetSignDetailInfo() {
			getSignInfoPcAndH5({
				sid: this.sid,
			}).then((res) => {
				if (res.code != "200") {
					this.$message({
						showClose: true,
						message: res.message,
						type: "warning",
					});
				} else {
					this.needHandwritten = res.data.needHandwritten;



					this.signStatus = res.data.signStatus;




					// this.positonExistFlag = false;
					this.positonExistFlag = res.data.positonExist === "sealPosition";

					// res.data.signFileInfoArray.map((item) => {
					//   // 骑缝章框回显处理
					//   let pushArr = [];
					//   if (item.filePositionArray) {
					//     item.filePositionArray.map((posItem) => {
					//       if (posItem.sealLocationType == "paging") {
					//         posItem.positionPage = 1;
					//         for (let i = 2, len = item.filePages; i <= len; i++) {
					//           pushArr.push({
					//             positionId: posItem.positionId,
					//             positionPage: i,
					//             positionY: posItem.positionY,
					//             sealType: posItem.sealType,
					//             sealLocationType: "paging",
					//           });
					//         }
					//       }
					//     });
					//     item.filePositionArray.push(...pushArr);
					//   }
					// });
					res.data.signFileInfoArray.map((item, idx) => {
						item.current = 0;
						item.fileImgArray = item.fileImgArray.map((imgItem, imgIdx) => {
							let poss;
							if (item.filePositionArray) {
								poss = item.filePositionArray.filter((posItem) => {
									return posItem.positionPage - 1 == imgIdx;
								});
							}
							let obj = {};
							obj.src = imgItem;
							if (!this.signSucceed) {
								obj.poss = poss;
							}
							return obj;
						});
					});
					this.signFileInfoArray = res.data.signFileInfoArray;
					this.sealInfoArray = res.data.sealInfoArray;
					this.lastActive = this.active;

					// if (res.data.positonExist === "sealPosition") {

					// }

					this.$nextTick(() => {
						document.getElementsByClassName("contract-img")[0].onload = (
							ev
						) => {
							this.renderOK = true;
							document.getElementsByClassName("contract-img")[0].onload = null;
						};

						let collapseContentNodeList = document
							.getElementsByClassName("contract-page")[0]
							.getElementsByClassName("el-collapse-item__content");
						for (
							let i = 0, len = collapseContentNodeList.length;
							i < len;
							i++
						) {
							collapseContentNodeList[i].style.maxHeight =
								document.getElementsByClassName("contract-page")[0]
									.offsetHeight -
								45 -
								48 * res.data.signFileInfoArray.length +
								"px";
						}
					});
				}
			});
		},
		handleSave() {
			if (!document.querySelectorAll(".contract-img")[0]) {
				return;
			}

			if (Array.from(document.querySelectorAll(".file-item")).some(item => {
				return !item.querySelector(".drag-box")
			})) {
				this.$message({
					message: "文件未盖章，请参考左侧栏【操作帮助】进行操作",
					type: "warning",
				});
				return;
			}




			let positionLocationList = [];
			let contractWidth =
				+document
					.getElementById("contract-imgs")
					.getElementsByClassName("file-item")
				[this.active].getElementsByClassName("contract-img")[0].offsetWidth;
			let contractHeight =
				+document
					.getElementById("contract-imgs")
					.getElementsByClassName("file-item")
				[this.active].getElementsByClassName("contract-img")[0].offsetHeight;
			this.$refs.contract.querySelectorAll(".drag-box").forEach((item) => {
				let isPaging = item.getAttribute("data-type") == "paging";
				let obj = {
					sealId: item.getAttribute("data-seal-id"),
					sealType: item.getAttribute("data-seal-type"),
					sealLocationType: isPaging ? "paging" : "position"
				};
				if (this.positonExistFlag) {
					obj.positionId = item.parentNode.parentNode.getAttribute("data-pos-id");
				} else {
					obj.signFileId = this.signFileInfoArray[item.getAttribute("data-file")].signFileId;
					if (!isPaging) {
						obj.positionX = parseInt(
							(+item.style.left.split("px")[0] / contractWidth) * 50000
						);
						obj.positionPage = +item.getAttribute("data-page") + 1;
					}
					obj.positionY = parseInt(
						(+item.style.top.split("px")[0] / contractHeight) * 50000
					);
				}
				// 非首页的骑缝章忽略掉，相当于去重
				if (!isPaging || (isPaging && item.getAttribute("data-page") == 0)) {
					positionLocationList.push(obj);
				}
			});


			let companyCommonCount = 0, companyPagingCount = 0, date = 0;
			positionLocationList.map(item => {
				if (item.sealType == "date") {
					date++;
				} else if (item.sealLocationType == "paging") {
					companyPagingCount++;
				} else if (item.sealType == "companyCommon") {
					companyCommonCount++;
				}
			})


			this.$confirm(`本次签署加盖${positionLocationList.length}个印章（${companyCommonCount > 0 ? companyCommonCount + '企业章；' : ''}${companyPagingCount > 0 ? companyPagingCount + '企业骑缝章；' : ''}${date > 0 ? date + '日期章；' : ''}） 确认无误后点击确认。`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {

				let loadingInstance = Loading.service({
					fullscreen: true,
				});
				this.signFinishLoading = true;


				signPcAndH5({
					// authid: this.authid,
					sid: this.sid,
					positionSealArray: positionLocationList,
				})
					.then((res) => {
						this.$nextTick(() => {
							// 以服务的方式调用的 Loading 需要异步关闭
							loadingInstance.close();
						});
						if (res.code != 200) {
							this.signFinishLoading = false;
							this.$message({
								showClose: true,
								message: res.message,
								type: "warning",
							});
						} else {
							this.signSucceed = true;
							this.$message({
								message: "签署成功！",
								type: "success",
							});
							if (res.data.returnUrl) {
								this.countDownSecond = 5;
								var timer = setInterval(() => {
									this.countDownSecond--;
									if (this.countDownSecond <= 0) {
										this.countDownSecond = 0;
									}
								}, 1000)
								setTimeout(() => {
									this.signFinishLoading = false;
									timer = null;
									this.countDownSecond = 0;
									clearInterval(timer);
									location.href = res.data.returnUrl;
								}, 5000);
							} else {
								this.signFinishLoading = false;
								Array.from(document.querySelectorAll(".position-box")).map(item => {
									item.parentNode.removeChild(item);
								});
								Array.from(document.getElementsByClassName("contract-imgs")[0].querySelectorAll(".drag-box")).map(item => {
									item.parentNode.removeChild(item);
								});
								this.handleGetSignDetailInfo();
							}
						}
					})
					.catch((err) => {
						this.signFinishLoading = false;
						this.$nextTick(() => {
							loadingInstance.close();
						});
						console.log(err);
					});


			});






		},
		// 认证完，提交签署签署
		getAuthCodeHandle(data) {
			this.saveLoading = true;
			if (this.applyData) {
				signWithProcess({
					sid: this.sid,
					positionSealArray: this.positionSealArray,
					signAuthToken: data.signAuthToken,
					processName: this.applyForm.processName,
					processDesc: this.applyForm.processDesc,
				}).then((res) => {
					this.saveLoading = false;
					if (res.code != "200") {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning",
						});
					} else {
						this.applyOpen = false;
						this.$message({
							showClose: true,
							message: res.message,
							type: "success",
						});
						this.$router.push({
							path: "/user-space/contracts",
							query: {
								status: "all",
							},
						});
					}
				});
			} else {
				taskSign({
					sid: this.sid,
					positionSealArray: this.positionSealArray,
					signAuthToken: data.signAuthToken,
				}).then((res) => {
					this.saveLoading = false;
					if (res.code != "200") {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning",
						});
					} else {
						this.$message({
							showClose: true,
							message: res.message,
							type: "success",
						});
						this.$router.push({
							path: "/user-space/contracts",
							query: {
								status: "all",
							},
						});
					}
				});
			}
		},
		submitApplyHandle() {
			this.$refs.applyForm.validate((valid) => {
				if (valid) {
					this.$refs.auth.dialogVisible = true;
				} else {
				}
			});
			// this.applyOpen = false;
		},
		cancelApply() {
			this.applyOpen = false;
		},
		arrayUnique(arr, name) {
			var hash = {};
			return arr.reduce(function (item, next) {
				hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
				return item;
			}, []);
		},

		/**
			  *@method judgePage
			*@description 判定落在哪页，只针对 top 值
			*@param {Object} target 判定目标 dom 对象
			*@param {Number} targetTop 判定目标 dom 对象 top 值
			*@param {Number} pageHeight 外层 dom 对象高度
			*@param {Number} offsetHeight 判定目标 dom 对象高度
			*@return 无返回，改变原对象
		*/
		judgePage(target, targetTop, pageHeight, offsetHeight) {
			let gutterHeight = 0;
			if (document.querySelectorAll(".img-wrap")[1]) {
				gutterHeight = +window
					.getComputedStyle(document.querySelectorAll(".img-wrap")[1], null)
					.marginTop.split("px")[0];
			}
			// 判定范围
			const judgeScope = (offsetHeight - gutterHeight) / 2 + gutterHeight;
			const judgeExpression =
				targetTop -
				(Math.ceil(targetTop / (pageHeight + gutterHeight)) *
					(pageHeight + gutterHeight) -
					(gutterHeight + offsetHeight) / 2);
			// 多页计算

			let divider = target.getAttribute("data-page")
				? +target.getAttribute("data-page")
				: 0;

			divider += Math.floor(targetTop / (pageHeight + gutterHeight));

			if (divider < 0) {
				divider = 0;
				target.style.top = 0;
			} else {
				if (Math.abs(judgeExpression) < judgeScope) {
					// 进入判定范围
					const nextPageHeight =
						(pageHeight + gutterHeight) *
						Math.ceil(targetTop / (pageHeight + gutterHeight));
					if (judgeExpression <= 0) {
						// 移到上一页
						target.style.top = pageHeight - offsetHeight + "px";
					} else {
						// 移到下一页
						target.style.top = 0 + "px";
						divider++;
					}
				} else {
					target.style.top =
						((pageHeight + gutterHeight + targetTop) %
							(pageHeight + gutterHeight)) +
						"px";
				}
			}

			if (divider > this.contractImgs.length - 1) {
				divider = this.contractImgs.length - 1;
				target.style.top = pageHeight - offsetHeight + "px";
			}

			target.setAttribute("data-page", divider);
		},

		handleNewHandWrite() {
			this.handWriteDialogVisible = true;
			const _this = this;
			this.$nextTick(() => {
				_this.showDrawTip();
				const $main = document.querySelector("#seal-main");
				const canvas = document.querySelector("#seal-canvas");
				const signCanvas = document.querySelector("#draw-seal");
				const $drawTip = document.querySelector(".draw-tip");
				const ctx = canvas.getContext("2d");
				canvas.width = signCanvas.clientWidth;
				canvas.height = signCanvas.clientHeight;
				let lastPoint = null;

				$main.addEventListener("mousedown", (e) => {
					_this.hideDrawTip();
					let isDown = true;
					let drwawTipLeft = $drawTip.offsetLeft;
					let drwawTipTop = $drawTip.offsetTop;

					ctx.lineWidth = 3;
					ctx.strokeStyle = "#000000";
					ctx.lineCap = ctx.lineJoin = "round";
					// let x = (e.target.tagName == "CANVAS") ? e.layerX : (e.layerX + drwawTipLeft);
					// let y = (e.target.tagName == "CANVAS") ? e.layerY : (e.layerY + drwawTipTop);
					// ctx.lineTo(x, y);

					$main.addEventListener("mousemove", (e) => {
						if (!isDown) {
							return;
						}
						e.preventDefault();
						let x = (e.target.tagName == "CANVAS") ? e.layerX : (e.layerX + drwawTipLeft);
						let y = (e.target.tagName == "CANVAS") ? e.layerY : (e.layerY + drwawTipTop);

						if (lastPoint != null) {
							ctx.beginPath();
							ctx.moveTo(lastPoint.x, lastPoint.y);
							ctx.lineTo(x, y);
							ctx.stroke();
						}
						lastPoint = { x, y }
						// ctx.lineTo(x, y);

					});

					document.addEventListener("mouseup", (e) => {
						ctx.closePath();
						e.preventDefault();
						isDown = false;
						lastPoint = null;
						canvas.onmousemove = null;
						canvas.onmouseup = null;
						canvas.removeEventListener("mousemove", e => { });
						document.removeEventListener("mouseup", e => { });
					});

				});


			})
		},

		clearSign() {
			const canvas = document.querySelector("#seal-canvas");
			const signCanvas = document.querySelector("#draw-seal");
			const ctx = canvas.getContext("2d");
			ctx.clearRect(
				0,
				0,
				signCanvas.offsetWidth,
				signCanvas.offsetHeight
			);
			this.showDrawTip();
		},
		drawSign() {
			const basedata = document
				.querySelector("#seal-canvas")
				.toDataURL("image/png", 1);
			checkHandwrite({
				sid: this.sid,
				imgBase64: basedata
			}).then((res) => {
				if (res.code != "200") {
					this.$message({
						showClose: true,
						message: res.message,
						type: "warning",
					});
				} else {
					this.$store.commit("SET_HANDWRITEBASE64", basedata);
					this.$store.commit("SET_HANDWRITEBASESEALID", res.data.sealId);
					this.customHandwriteImg = basedata;
					this.handWriteDialogVisible = false;
					this.customHandwriteSealId = res.data.sealId;
				}
			}).catch(err => {
				console.log(err)
			})
		},
		hideDrawTip() {
			const drawTip = document.querySelector(".draw-tip");
			drawTip.style.display = "none";
		},

		showDrawTip() {
			const drawTip = document.querySelector(".draw-tip");
			drawTip.style.display = "block";
		},

		confirmDeleteHandwrite() {
			this.$confirm(`确定要删除当前手写签名吗？`, "提示", {
				confirmButtonText: "删除",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$store.commit("SET_HANDWRITEBASE64", null);
					this.$store.commit("SET_HANDWRITEBASESEALID", null);
					this.customHandwriteImg = null;
				})
				.catch(() => { });
		},

		handleAutoSeal() {
			let sealInfoArrayCopy = JSON.parse(JSON.stringify(this.sealInfoArray));
			let arrayMap = {};
			sealInfoArrayCopy.map(item => {
				item.check = false;
				if (!arrayMap[item.sealType]) {
					arrayMap[item.sealType] = [item]
				} else {
					arrayMap[item.sealType].push(item)
				}
			})
			this.sealInfoArrayMapAutoSeal = arrayMap;
			this.autoSealDialogVisible = true;
		},

		handleSelectAutoSeal(item, list) {
			list.map(_item => {
				_item.check = false;
			})
			item.check = true;
		},

		handleCheckAutoSeal() {
			let checkedSealList = [];
			Object.keys(this.sealInfoArrayMapAutoSeal).map(key => {
				this.sealInfoArrayMapAutoSeal[key].map(item => {
					if (item.check) {
						item.node = document.getElementById("set-sign").querySelector(`.sign-box[data-seal-id="${item.sealId}"]`);
						checkedSealList.push(item)
					}
				})
			})
			let positionBoxList = Array.from(document.querySelectorAll(".position-box"));
			checkedSealList.map(item => {
				positionBoxList.map(nodeItem => {
					if (nodeItem.getAttribute("data-seal-type") == item.sealType) {
						let itemNodeClone = item.node.cloneNode(true);
						itemNodeClone.style.position = "relative";
						itemNodeClone.style.left = "unset";
						itemNodeClone.style.top = "unset";
						const deleteDom = document.createElement("i");
						deleteDom.setAttribute(
							"class",
							"el-icon-circle-close delete-icon"
						);
						deleteDom.addEventListener("click", function () {
							itemNodeClone.parentNode.removeChild(itemNodeClone);
						});
						itemNodeClone.appendChild(deleteDom);
						if (nodeItem.querySelector(".sign-box")) {
							nodeItem.querySelector(".sign-box").parentNode.removeChild(nodeItem.querySelector(".sign-box"))
						}
						nodeItem.lastElementChild.appendChild(itemNodeClone);
					}
				})
			})
			this.autoSealDialogVisible = false;
		}


	},
	directives: {
		drop: {
			inserted: function (el, binding, vnode) {
				let disX = 0;
				let disY = 0;
				let contractImgs =
					document.querySelector("#contract-imgs").parentNode.parentNode;
				let contractDom = document.querySelector("#contract-imgs");
				let contractContractDom = document.querySelector(".contract-content");
				let main = document.querySelector("#main");
				let asideDom = document.querySelector("#set-sign");

				// 获取所有图片，拖拽不在浏览器新页面打开
				Array.from(document.getElementsByTagName("img")).forEach((img) => {
					img.ondragstart = function () {
						return false;
					};
				});

				el.onmousedown = function (event) {
					const asideTop = asideDom.getBoundingClientRect().top;
					const asideLeft = asideDom.getBoundingClientRect().left;
					const scrollTop = document.querySelector(".seal-list-wrap").scrollTop;
					event = event || window.event;
					disX = event.clientX - this.offsetLeft;
					disY = event.clientY - this.offsetTop + asideDom.scrollTop;
					let cloneTemp = el.cloneNode(true);
					cloneTemp.style.position = "fixed";
					cloneTemp.style.zIndex = 999;
					cloneTemp.style.left = this.currentStyle
						? this.currentStyle["left"]
						: getComputedStyle(this, null)["left"];
					cloneTemp.style.top = event.clientY - disY + main.offsetTop - scrollTop + "px";
					cloneTemp.style.cursor = "grab";
					cloneTemp.style.opacity = ".4";
					el.parentNode.appendChild(cloneTemp);

					document.onmousemove = function (event) {
						event = event || window.event;
						let iL = event.clientX - disX;
						let iT = event.clientY - disY;
						let maxL = document.documentElement.clientWidth - el.offsetWidth;
						let maxT = document.documentElement.clientHeight - el.offsetHeight;
						iL <= 0 && (iL = 0);
						iT <= 0 && (iT = 0);
						iL >= maxL && (iL = maxL);
						iT >= maxT && (iT = maxT);
						cloneTemp.style.left = iL + main.offsetLeft + "px";
						cloneTemp.style.top = iT + main.offsetTop - scrollTop + "px";
						return false;
					};

					// 兼容有章框和无章框情况，统一判断处理
					document.onmouseup = function (event) {
						event = event || window.event;
						let targetLeft = +cloneTemp.style.left.split("px")[0];
						let targetTop = +cloneTemp.style.top.split("px")[0];
						let targetWidth = +cloneTemp.offsetWidth;
						let targetHeight = +cloneTemp.offsetHeight;
						let targetSealType = cloneTemp.getAttribute("data-seal-type");
						let targetWrapScrollLeft = +contractContractDom.scrollLeft;
						console.log(targetWrapScrollLeft)
						document.onmousemove = null;
						document.onmouseup = null;
						// 无签章框情况
						if (!vnode.context.positonExistFlag) {
							let contractDomLeft = contractDom.getBoundingClientRect().left;
							let contractDomTop = contractDom.getBoundingClientRect().top;
							if (
								targetLeft >= contractDomLeft + targetWrapScrollLeft &&
								targetLeft <=
								contractDomLeft + contractDom.offsetWidth - targetWidth + targetWrapScrollLeft &&
								targetTop >= contractDomTop &&
								targetTop <=
								contractDomTop + contractDom.offsetHeight - targetHeight
							) {
								targetTop = targetTop - contractDomTop;
								targetLeft = targetLeft - contractDomLeft;
								const pageHeight = contractDom
									.querySelectorAll(".file-item")
								[vnode.context.active].querySelectorAll(
									".contract-img"
								)[0].offsetHeight;
								const headDom = document.createElement("div");
								headDom.setAttribute("class", "box-head");
								let type = vnode.context.isPaging && targetSealType == "companyCommon" ? "paging" : "";
								const deleteDom = document.createElement("i");
								deleteDom.setAttribute("class", "el-icon-circle-close delete-icon");
								deleteDom.addEventListener("click", function () {
									cloneTemp.parentNode.removeChild(cloneTemp);
								});
								headDom.appendChild(deleteDom);
								cloneTemp.appendChild(headDom);
								cloneTemp.setAttribute("data-file", vnode.context.active);
								cloneTemp.style.position = "absolute";
								cloneTemp.style.left = targetLeft + "px";
								cloneTemp.style.top = targetTop + "px";
								cloneTemp.style.opacity = "1";
								contractDom.appendChild(cloneTemp);
								targetWidth = +cloneTemp.offsetWidth;
								targetHeight = +cloneTemp.offsetHeight;
								let contractContractDomScrolledWidth = contractContractDom.querySelector(".img-wrap").offsetWidth - contractContractDom.querySelector(".contract-img-content").offsetWidth;
								// 签框不能超出合同图片宽，骑缝章处理
								if (

									type == "paging"
								) {
									cloneTemp.style.left =
										contractDom.offsetWidth - targetWidth + contractContractDomScrolledWidth + "px";
								}
								vnode.context.judgePage(
									cloneTemp,
									targetTop,
									pageHeight,
									targetHeight
								);
								// 向每一页添加骑缝章
								if (type == "paging") {
									const targetPagingId =
										"paging" + vnode.context.active + vnode.context.pagingId;
									cloneTemp.setAttribute("data-paging", targetPagingId);
									cloneTemp.setAttribute("data-type", "paging");
									cloneTemp.className += " paging-box";
									vnode.context.pagingId++;
									const allPageDoms = contractDom
										.querySelectorAll(".file-item")
									[vnode.context.active].querySelectorAll(".img-wrap");
									for (let i = 0; i < allPageDoms.length; i++) {
										let secondColoneTemp =
											i == 0 ? cloneTemp : cloneTemp.cloneNode(true);
										secondColoneTemp.setAttribute("data-page", i);
										secondColoneTemp
											.getElementsByClassName("delete-icon")[0]
											.addEventListener("click", function () {
												// 删除每一个骑缝章
												const allTargetPagingDoms = contractDom
													.querySelectorAll(".file-item")
												[vnode.context.active].querySelectorAll(
													'.paging-box[data-paging="' + targetPagingId + '"]'
												);
												for (let i = 0; i < allTargetPagingDoms.length; i++) {
													allTargetPagingDoms[i].parentNode.removeChild(
														allTargetPagingDoms[i]
													);
												}
											});
										allPageDoms[i].appendChild(secondColoneTemp);
									}
								} else {
									contractDom
										.querySelectorAll(".file-item")
									[vnode.context.active].querySelectorAll(".img-wrap")
									[cloneTemp.getAttribute("data-page")].appendChild(cloneTemp);
								}
							} else {
								el.parentNode.removeChild(cloneTemp);
							}
						} else {
							cloneTemp.style.position = "absolute";
							cloneTemp.style.zIndex = 9;
							cloneTemp.style.opacity = 1;
							cloneTemp.style.left =
								targetLeft -
								contractDom.offsetLeft +
								contractDom.parentNode.parentNode.scrollLeft -
								asideLeft +
								"px";
							cloneTemp.style.top =
								targetTop +
								contractDom.parentNode.parentNode.scrollTop -
								asideTop +
								"px";

							targetLeft = +cloneTemp.style.left.split("px")[0];
							targetTop = +cloneTemp.style.top.split("px")[0];

							// 判定落入签章框
							const sealAnchors = contractDom
								.querySelectorAll(".file-item")
							[vnode.context.active].querySelectorAll(".position-box");
							const judgeScope = vnode.context.judgeScope;
							let catcher = null;

							for (let i = 0, len = sealAnchors.length; i < len; i++) {
								// 取两判定物体中心点比较
								let sealAnchorCenterLeft =
									sealAnchors[i].offsetLeft + sealAnchors[i].offsetWidth / 2;
								let sealAnchorCenterTop =
									sealAnchors[i].parentNode.offsetTop +
									sealAnchors[i].offsetTop +
									sealAnchors[i].offsetHeight / 2;
								let targetCenterLeft = targetLeft + targetWidth / 2;
								let targetCenterTop = targetTop + targetHeight / 2;
								if (
									Math.abs(sealAnchorCenterLeft - targetCenterLeft) <=
									judgeScope &&
									Math.abs(sealAnchorCenterTop - targetCenterTop) <=
									judgeScope
								) {
									// 去掉30 box-head 标题高度
									// 落入捕获
									catcher = sealAnchors[i];
								}
							}
							if (catcher) {
								// 骑缝章可以拖入签章和签名
								if (
									cloneTemp.getAttribute("data-seal-type") !==
									catcher.getAttribute("data-seal-type")
								) {
									vnode.context.$message({
										message: "您不能在此位置盖章",
										type: "warning",
									});
									el.parentNode.removeChild(cloneTemp);
									return;
								}

								if (catcher.getElementsByClassName("drag-box")[0]) {
									vnode.context.$message({
										message: "要拖入的签章位置已存在其他签章",
										type: "warning",
									});
									el.parentNode.removeChild(cloneTemp);
									return;
								}

								if (catcher.getAttribute("data-type") == "paging") {
									// 为所有同一positionId骑缝章框加入骑缝章
									const allPagingPosBoxDoms = contractDom
										.querySelectorAll(".file-item")
									[vnode.context.active].querySelectorAll(
										'.position-box[data-pos-id="' +
										catcher.getAttribute("data-pos-id") +
										'"] .paging-pos-box'
									);
									for (let i = 0; i < allPagingPosBoxDoms.length; i++) {
										let secondColoneTemp =
											i == 0 ? cloneTemp : cloneTemp.cloneNode(true);
										secondColoneTemp.style.position = "relative";
										secondColoneTemp.style.left = "unset";
										secondColoneTemp.style.top = "unset";
										const deleteDom = document.createElement("i");
										deleteDom.setAttribute(
											"class",
											"el-icon-circle-close delete-icon"
										);
										deleteDom.addEventListener("click", function (e) {
											// 删除所有相同id的骑缝章
											const targetPagingId = catcher.getAttribute("data-pos-id");
											const allTargetPagingDoms = contractDom
												.querySelectorAll(".file-item")
											[vnode.context.active].querySelectorAll(
												'.position-box[data-pos-id="' +
												targetPagingId +
												'"] .drag-box'
											);
											for (let i = 0; i < allTargetPagingDoms.length; i++) {
												allTargetPagingDoms[i].parentNode.removeChild(
													allTargetPagingDoms[i]
												);
											}
										});
										secondColoneTemp.appendChild(deleteDom);
										allPagingPosBoxDoms[i].appendChild(secondColoneTemp);
									}
								} else {
									cloneTemp.style.position = "relative";
									cloneTemp.style.left = "unset";
									cloneTemp.style.top = "unset";
									const deleteDom = document.createElement("i");
									deleteDom.setAttribute(
										"class",
										"el-icon-circle-close delete-icon"
									);
									deleteDom.addEventListener("click", function () {
										cloneTemp.parentNode.removeChild(cloneTemp);
									});
									cloneTemp.appendChild(deleteDom);
									catcher.lastElementChild.appendChild(cloneTemp);
								}
							} else {
								el.parentNode.removeChild(cloneTemp);
							}
						}
					};
				};
			},
		},
		maxIndex: {
			inserted: function (el, binding) {
				var customDrags = document.getElementsByClassName("custom-drag");
				el.onclick = function () {
					for (var i = 0; i < customDrags.length; i++) {
						customDrags[i].style.zIndex = 9;
					}
					el.style.zIndex = 9999;
				};
			},
		},
	},
};
</script>
<style lang="scss" scoped>
.select-sign {
	// width: 152px;
	margin: 20px 26px;
	text-align: center;
}

.select-sign-title {
	font-size: 14px;
	color: #666666;
	text-align: center;
}

.sign-item {
	// width: 46px;
	text-align: center;
	font-size: 0;
	display: inline-block;
	margin: 2px 8px 2px;

	.sign-img-box {

		// &[data-seal-type="companyCommon"] {
		//   width: 109px;
		// }
		&[data-seal-type="person"] {
			width: 64.5px;
		}

		// width: 109px;
		width: 128px;
		text-align: center;
		border: 1px solid #f0f0f5;
		border-radius: 4px;
		font-size: 0;
		cursor: grab;

		img {
			max-width: 100%;
			height: auto;
			vertical-align: middle;
			user-select: none;
		}
	}

	span {
		display: inline-block;
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		margin-top: 5px;
	}
}

.contract-content {
	/* width: 685px; */
	background: #f0f0f5;
	/* position: relative; */
	// height: calc(100vh - 128px);
	height: 100vh;

	overflow-y: auto;
	overflow-x: auto;
	/* overflow: auto; */

	.drag-box {
		// background: rgba(255, 255, 255, 0.7);
		// border-radius: 10px;
		// overflow: hidden;

		&.sign-box {
			// width: 109px;
			// height: 109px;
			// margin: 8px auto;
			width: 127px;
			margin: auto;

			/deep/ img {
				display: block;
				max-width: 100%;
				height: auto;
				user-select: none;
			}

			// border: 1px solid #33cccc;
		}

		&.sign-box[data-seal-type="person"] {
			width: 63.5px;
			// height: 93.5px;
			// border: 1px solid #33cccc;
		}

		&.sign-box[data-type="paging"] {

			transform: translateX(50%);

			/deep/ .box-head {
				right: 50%;
			}
		}

		// &.seal-box {
		// 	width: 127px;
		// 	height: 157px;
		// 	border: 1px solid #33cccc;
		// }
		// &.date-box {
		// 	width: 127px;
		// 	height: 66px;
		// 	border: 1px solid #33cccc;
		// }
		/deep/ .box-head {
			color: #f56c6c;

			display: flex;
			justify-content: space-between;
			align-items: center;
			position: absolute;
			right: -9px;
			top: -9px;

			.el-icon-circle-close {
				font-weight: bold;
				font-size: 26px;
				cursor: pointer;
			}
		}
	}
}

.contract-page {
	min-width: 175px;
	width: 238px;
	background: #fff;
	// height: calc(100vh - 128px);
	height: 100vh;
	overflow: hidden;
	border-left: 1px solid #EBEEF5;

	.el-collapse {
		max-height: calc(100% - 45px);

		/deep/ .el-collapse-item {
			// height: 100%;
			.el-collapse-item__header {
				padding: 0 10px 0 15%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 95%;
				display: block;
				position: relative;

				.el-collapse-item__arrow {
					position: absolute;
					left: 5%;
					top: 0;
					bottom: 0;
					margin: auto 0;
					width: 13px;
					height: 13px;
				}
			}

			.el-collapse-item__wrap {

				// height: calc(100% - 48px);
				.el-collapse-item__content {
					overflow: auto;
					background: #f9f9ff;
					padding-top: 25px;
					padding-bottom: 1px;
				}
			}
		}
	}

	.pages-head {
		height: 45px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 17px;
		padding-right: 13px;
		background: #ffffff;

		.big {
			font-size: 16px;
			font-weight: bold;
			color: #333333;
		}

		.sub {
			font-size: 14px;
			font-weight: 400;
			color: #999999;
		}
	}

	.page-wrap {
		width: 160px;
		margin: 0 auto;

		img {
			display: block;
			margin: 0 auto;
			width: 100%;

			&.current {
				outline: 1px solid #3699ff;
				box-shadow: 0px 3px 10px 0px rgba(54, 153, 255, 0.1);
			}
		}

		.page {
			font-size: 12px;
			font-weight: 400;
			color: #999999;
			text-align: center;
			margin: 12px 0;

			&.current {
				color: #3699ff;
			}
		}
	}

	/* overflow-y: auto; */
	/* overflow-x: hidden; */
}

#sign-layer {
	background: #f0f0f5;
	height: 100vh;
	overflow: hidden;
}

header {
	width: 100%;
	height: 71px;
	background: rgba(35, 43, 58, 1);
	box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
	line-height: 71px;
	overflow: hidden;
}

.header-center {
	width: 1200px;
	margin: 0 auto;
	line-height: 71px;
	height: 71px;
	overflow: hidden;
	position: relative;
}

.return-index {
	height: 71px;
	display: block;
	position: absolute;
	right: 0;
	top: 0;
	font-size: 24px;
	color: #ffffff;
	line-height: 71px;
}

.setcontrol-content {
	max-width: 1200px;
	margin: 0 auto 0;
	// margin: 30px auto 0;
	display: flex;
	justify-content: space-between;
	position: relative;
	width: 100%;
}

.set-sign-control {
	width: 238px;
	min-width: 175px;
	background: white;
	position: relative;
	z-index: 9;
	overflow-y: auto;
	// height: calc(100vh - 128px);
	height: 100vh;
	border-right: 1px solid #EBEEF5;

	/deep/ .el-collapse-item {
		// height: 100%;
		.el-collapse-item__header {
			padding: 0 10px 0 15%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			width: 95%;
			display: block;
			position: relative;

			.el-collapse-item__arrow {
				position: absolute;
				left: 5%;
				top: 0;
				bottom: 0;
				margin: auto 0;
				width: 13px;
				height: 13px;
			}
		}

		.el-collapse-item__wrap {

			// height: calc(100% - 48px);
			.el-collapse-item__content {
				overflow: auto;
				background: #f9f9ff;
				padding-top: 25px;
				padding-bottom: 1px;
			}
		}
	}

	.pages-head {
		width: 100%;
		height: 45px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 17px;
		padding-right: 13px;
		border-top: 1px solid #EBEEF5;
		border-bottom: 1px solid #EBEEF5;

		.big {
			font-size: 16px;
			font-weight: bold;
			color: #333333;
		}

		.sub {
			font-size: 14px;
			font-weight: 400;
			color: #999999;
		}
	}
}

.auto-seal-btn-wrap {
	text-align: center;
	padding: 0 0 25px;
}

.auto-seal-btn {
	width: 128px;
	// position: absolute;
	// left: 50%;
	// top: unset;
	// transform: translateX(-50%);
}

.set-title {
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	border-left: 3px solid #3699ff;
	text-indent: 13px;
	margin: 20px 0 0 27px;

	.tag {
		padding: 1px 4px;
		border: 2px solid #3699ff;
		border-radius: 7px;
		font-size: 12px;
		font-weight: bold;
		color: #3699ff;
		display: inline-block;
		text-indent: 0;
		text-align: center;
		margin-left: -9px;
		margin-right: 11px;

		&.process {
			border: 2px solid #00d9d6;
			color: #00d9d6;
		}
	}
}

.set-title-padding {
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	margin: 12px 27px 12px 27px;

	&+.set-title-padding {
		margin-top: 0;
	}
}

.contract-img-content {
	/* height: calc(100vh - 134px);
	overflow-y: auto;
	position: relative; */

	/* position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 2; */

	height: 100%;
}

.contract-imgs {
	position: relative;
	z-index: 1;

	.file-item {
		width: 665px;
		overflow: hidden;
	}
}

.contract-imgs .contract-img {
	display: block;
	width: 665px;
	height: auto;
	/* border-bottom: 2px solid #eee; */
	box-sizing: content-box;
	-ms-box-sizing: content-box;
}

.contract-imgs .orther-box-sign {
	max-width: 80px;
	max-height: 80px;
}

.contract-imgs .img-wrap {
	position: relative;
	width: 665px;

	.position-box {
		position: absolute;
		overflow: hidden;

		// border-radius: 10px;
		&[data-type="paging"] {
			// border-radius: 10px 0 0 10px;
		}

		.sign-pos-box {
			width: 64.5px;
			height: 64.5px;
			border: 1px solid #33cccc;
			background: rgba(255, 255, 255, 0.7);
			// border-radius: 10px;
			// overflow: hidden;
		}

		.seal-pos-box {
			width: 128px;
			height: 128px;
			border: 1px solid #33cccc;
			background: rgba(255, 255, 255, 0.7);
			// border-radius: 10px;
			overflow: hidden;
		}

		.date-pos-box {
			width: 128px;
			height: 31px;
			border: 1px solid #33cccc;
			background: rgba(255, 255, 255, 0.7);
			// border-radius: 10px;
			overflow: hidden;
		}

		.paging-pos-box {
			width: 50px;
			height: 128px;
			border: 1px solid #33cccc;
			background: rgba(255, 255, 255, 0.7);
			// border-radius: 10px 0 0 10px;
			overflow: hidden;

			/deep/ .box-head {
				span {
					position: absolute;
					top: 40px;
					left: 4px;
					color: #aaa;
				}
			}
		}

		/deep/ .box-head {
			width: 100%;
			min-height: 30px;
			color: #fff;
			background: #33cccc;
			font-size: 12px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 3px 0 8px;
			position: absolute;
			left: 0;
			top: 0;

			.el-icon-close {
				cursor: pointer;
				padding: 5px;
			}
		}
	}
}

.contract-imgs .img-wrap+.img-wrap {
	margin-top: 30px;
}

/* .contract-img {
																																																																																																								width: 685px;
																																																																																																							} */

.custom-drag {
	width: 127px;
	height: 127px;
	border: 1px solid rgba(51, 204, 204, 1);
	position: absolute;
	left: 0;
	top: 0;
	z-index: 3;
	cursor: move;
	/* box-sizing: content-box;
																																																																																																								-ms-box-sizing: content-box; */
}

.custom-content {
	width: 127px;
	height: 127px;
	background: rgba(255, 255, 255, 0.7);
	position: relative;
	z-index: 1;
}

.custom-drag-title {
	font-size: 16px;
	color: #000000;
	display: block;
	width: 127px;
	top: 50px;
	display: block;
	position: absolute;
	z-index: -1;
	text-align: center;
}

.custom-drag-time {
	position: absolute;
	bottom: 8px;
	text-align: center;
	font-size: 16px;
	color: #bbb;
	display: block;
	width: 127px;
	z-index: 9999;
}

.custom-drag-header {
	width: 109px;
	height: 33px;
	background: rgba(51, 204, 204, 1);
	line-height: 33px;
	font-size: 16px;
	color: #ffffff;
	padding: 0 10px;
	/* display: flex;
																																																																																																								justify-content: space-between; */
	position: absolute;
	left: -1px;
	top: -33px;
}

.custom-drag-header .delete {
	cursor: pointer;
	float: right;
	margin-right: 5px;
}

.custom-delete {
	font-size: 14px;
	width: 60px;
	height: 22px;
	background: rgba(0, 0, 0, 0.5);
	text-align: center;
	color: #ffffff;
	display: block;
	line-height: 22px;
	position: absolute;
	left: 30px;
	bottom: -22px;
	display: none;
}

.all-page {
	width: 180px;
	margin: 30px auto 0;
}

.page-item {
	position: relative;
	height: 230px;
	margin-bottom: 22px;
}

.page-img {
	width: 177px;
	height: 238px;
	border: 1px solid rgba(240, 240, 245, 1);
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	cursor: pointer;
	position: relative;
}

.page-img img {
	display: block;
	max-width: 177px;
	max-height: 198px;
}

.page-text {
	text-align: center;
	font-size: 14px;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	color: #333333;
}

.sign-default,
.sign-orther {
	width: 152px;
	height: 152px;
	background: #f9f9f9;
	overflow: hidden;
	margin-top: 30px;
}

.sign-default-title {
	text-align: center;
	font-size: 14px;
	color: #999999;
	line-height: 34px;
}

.default-box,
.orther-sign-box {
	width: 80px;
	height: 80px;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 5px auto 0;
	background: #ffffff;
	border: 1px solid rgba(229, 229, 229, 1);
	/* position: relative; */
}

.default-box img,
.orther-box .orther-box-sign {
	display: block;
	max-width: 80px;
	max-height: 80px;
	cursor: move;
}

/* .personal{
																																																																																																							background: url('../../assets/images/sign/personal.png') no-repeat right top;
																																																																																																							} */

.type-icon {
	position: relative;
	left: 88px;
	top: -81px;
	/* transform: translateY(-50px); */
}

.sign-name {
	font-size: 14px;
	color: #333333;
	text-align: center;
	line-height: 34px;
	margin-top: -6px;
}

.orther-title {
	text-align: center;
	font-size: 16px;
	color: #333333;
	margin-top: 30px;
}

.sign-orther {
	width: 152px;
	margin: 15px auto 0;
}

.sign-orther {
	margin-top: 0;
}

.orther-box {
	margin-top: 20px;
	margin-bottom: 10px;
	height: 114px;
}

.orther-list {
	margin-top: 15px;
	padding-bottom: 40px;
}

.custom-sign-box {
	width: 127px;
	height: 127px;
	position: absolute;
	top: 0;
	left: 0;
	/* border: 1px solid red; */
	overflow: hidden;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
}

.custom-sign-box img {
	display: block;
	max-height: 127px;
	max-width: 127px;
}

.submit-btn {
	width: 279px;
	height: 42px;
	position: fixed;
	left: 50%;
	bottom: 50px;
	// margin-left: -168px;
	color: #ffffff;
	font-size: 16px;
	z-index: 999;
	transform: translateX(-50%);
}

.submit-btn button {
	width: 100%;
	display: block;
	font-size: 16px;
	float: left;
}

.page-img .sign-icon {
	width: 44px;
	height: 44px;
	position: absolute;
	right: 0;
	top: 0;
}

.sign-auth {
	text-align: center;
	font-size: 12px;
	color: red;
	margin-top: -40px;
	height: 17px;
}

.default {
	margin-top: -55px;
}

.drag-box /deep/ .delete-icon {
	font-size: 28px;
	position: absolute;
	color: #fff;
	font-weight: bold;
	right: 1px;
	top: 1px;
	display: none;
	cursor: pointer;
	background: red;
	border-radius: 50%;
}

.paging-pos-box .drag-box /deep/ .delete-icon {
	right: unset;
	top: -8px;
	left: 10px;
}

.drag-box:hover /deep/ .delete-icon {
	display: block;
}
</style>
<style lang="scss" scoped>
#draw-seal {
	width: 100%;
	height: 400px;
	user-select: none;
	position: relative;
}

#seal-canvas {
	/* width: 100%;
	height: 100%;
	background: white;
	position: absolute;
	left: 0;
	top: 0; */
	background: white;
}

.draw-tip {
	font-size: 14px;
	position: absolute;
	left: 50%;
	top: 50%;
	letter-spacing: 2px;
	text-align: center;
	transform-origin: 0 0;
	transform: translate(-50%, -50%);
}

.draw-tip img {
	display: inline-block;
	width: 30px;
}

.draw-tip p {
	margin-top: 14px;
	color: #666666;
}

.tip-success,
.tip-waning {
	width: 100%;
	position: fixed;
	left: 0;
	top: -0.8rem;
	background: #f0f9eb;
	z-index: 999;
	color: #67c23a;
	font-size: 0.16rem;
	text-align: center;
	height: 0.8rem;
	line-height: 0.8rem;
	transition: 0.5s;
}

.tip-waning {
	background: #fdf6ec;
	color: #e6a23c;
}

.handwrite-img-wrap {
	text-align: center;
	font-size: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.handwrite-img-wrap .drag-box {
	width: 64.5px;
	border: 1px solid #f0f0f5;
	border-radius: 4px;
}

.drag-box+.el-button {
	margin-left: 15px;
}

.handwrite-img-wrap img {
	display: block;
	width: 100%;
	height: auto;

}

.auto-seal-wrap {
	.set-title {
		margin: 20px 0 20px 0;
	}


	.auto-seal-list {
		display: grid;
		grid-gap: 1rem;
		grid-template-columns: repeat(auto-fit, minmax(128px, 0));
	}

	.auto-seal-item {
		width: 128px;
		border: 2px solid transparent;
		border-radius: 10px;
		padding: 10px;
		position: relative;
		cursor: pointer;

		img {
			max-width: 100%;
			height: auto;
			vertical-align: middle;
			user-select: none;
		}

		&.isCheck {
			border: 2px solid #409EFF;
		}

		i {
			position: absolute;
			right: 5px;
			bottom: 5px;
			color: #409EFF;
			font-size: 22px;
		}

	}


}
</style>
<style>
.handwrite-dialog {
	user-select: none;
}

.handwrite-dialog .el-dialog__body {
	padding: 0;
}

.autoseal-dialog .el-dialog__body {
	padding: 0 20px 30px;
}
</style>